import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  productName: validationNotEmpty("Product Name"),
  paymentType: validationNotEmpty("Payment Type"),
});
